export const ERROR_OCCURED = "ERROR_OCCURED";
export const POST_ERROR_OCCURED = "POST_ERROR_OCCURED";
export const LOGIN_ERROR = "LOGIN_ERROR";
